import { render, staticRenderFns } from "./task-config.vue?vue&type=template&id=3511b3ff&"
import script from "./task-config.vue?vue&type=script&lang=js&"
export * from "./task-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3511b3ff')) {
      api.createRecord('3511b3ff', component.options)
    } else {
      api.reload('3511b3ff', component.options)
    }
    module.hot.accept("./task-config.vue?vue&type=template&id=3511b3ff&", function () {
      api.rerender('3511b3ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/task/task-config.vue"
export default component.exports